import { compose, withHandlers, withStateHandlers } from 'recompose';
import { withDataLayerPush } from './withDataLayerPush';

export const withDataLayerProductDetailPush = compose(
  withDataLayerPush,
  withHandlers({
    dataLayerProductDetailPush: ({ dataLayerPush }) => ({
      productName,
      priceNet,
      thumbUrl,
      identifier,
      productConfig,
      fullFriendlyUrl,
    }) => {
      dataLayerPush({
        event: 'product',
        productName,
        priceNet,
        thumbUrl,
        identifier,
        productConfig,
        fullFriendlyUrl,
      });
    },
  }),
);

export const withJustInTimeProductDetail = compose(
  withStateHandlers({ productDetail: null }, {
    setProductDetail: () => productDetail => ({ productDetail })
  }),
);



// WEBPACK FOOTER //
// ./src/Common/GTM/withDataLayerProductDetail.js